// extracted by css-extract-rspack-plugin
export default {"section":"UnPeeJX_Ks0jaG4J"};